// eslint-disable-next-line import/prefer-default-export
export enum DateRangeFilterValues {
  default = '',
  all = 'all',
  today = 'today',
  weekend = 'weekend',
  month = 'month',
}
